import React from 'react'
import Container from '../../../components/Container'
import { Grid2, Typography } from '@mui/material'
import ProfileSettings from '../../../components/Screens/ProfileSettings'

const DashboardProfile = () => {
  return (
    <Container padding={2}>
      <ProfileSettings />
    </Container>
  )
}

export default DashboardProfile